import { useTranslation } from 'react-i18next';
import {
  IpponButton,
  IpponCard,
  IpponContainer,
  IpponHSpace,
  IpponIcon,
  IpponIconSurface,
  IpponText,
  IpponTitle,
  IpponVSpace,
} from '@ippon-ui/react';
import { logout } from '@/generic/authentication';

export const WithoutOrganizationComponent = () => {
  const { t } = useTranslation('cleanapi');

  return (
    <IpponContainer>
      <IpponHSpace align="center">
        <IpponCard size="large" shadow="l3" dataSelector="cleanapi.without-organization">
          <IpponVSpace gap={16} align="center">
            <IpponIconSurface color="information">
              <IpponIcon name="business" size={24} />
            </IpponIconSurface>
            <IpponVSpace gap={4} align="center">
              <IpponTitle tag="h1" level={5} dataSelector="cleanapi.without-organization.title">
                {t('cleanapi.without-organization.title')}
              </IpponTitle>
              <IpponText
                variant="body"
                size="small"
                color="neutral-tertiary"
                dataSelector="cleanapi.without-organization.description"
              >
                {t('cleanapi.without-organization.description')}
              </IpponText>
            </IpponVSpace>
            <IpponButton
              color="error"
              variant="text"
              iconLeft={{ name: 'log-out' }}
              onClick={logout}
              dataSelector="cleanapi.without-organization.log-out"
            >
              {t('cleanapi.without-organization.log-out')}
            </IpponButton>
          </IpponVSpace>
        </IpponCard>
      </IpponHSpace>
    </IpponContainer>
  );
};
